/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * TitlesApi - axios parameter creator
 * @export
 */
export const TitlesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new title.
         * @param {CreateTitleDto} createTitleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerCreate: (createTitleDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createTitleDto' is not null or undefined
            assertParamExists('titleControllerCreate', 'createTitleDto', createTitleDto);
            const localVarPath = `/title`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createTitleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all titles for a workspace.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        titleControllerFindAll: (workspaceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('titleControllerFindAll', 'workspaceId', workspaceId);
            const localVarPath = `/title`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all titles for a workspace.
         * @param {Array<ClaimStatusEnum>} [claimStatuses] Optional server-side filter by one or more claim statuses. Matches titles whose &#x60;claimStatus&#x60; is any of the given values.
         * @param {Array<string>} [clientIds] Owner client ids the frontend resolved from the search term (client names live in a separate DB, so the match happens client-side). When &#x60;name&#x60; is set, titles owned by any of these clients also match. Capped at 100 ids; &#x60;clientName&#x60; resolves the term server-side with no such cap.
         * @param {string} [clientName] Matches titles owned by clients whose name contains this term. Resolved server-side within &#x60;workspaceId&#x60;, which it requires.
         * @param {string} [name]
         * @param {Array<string>} [ownerClientIds] Optional server-side filter by owner client. Unlike &#x60;clientIds&#x60; — which the frontend resolves from the search term and which *widens* a name search — this narrows the result set, and so is AND-ed with every other filter.
         * @param {boolean} [seriesOnly] When true, return titles at series level: excludes child seasons/episodes (those carry a &#x60;serialTitleId&#x60;).
         * @param {Array<ServiceTypeEnum>} [serviceTypes] Optional server-side filter by one or more service types. Matches titles whose &#x60;serviceType[]&#x60; includes any of the given values.
         * @param {Array<string>} [titleIds] Optional server-side filter by title id, so a caller holding many ids (a CSV export naming each row\&#39;s title) reads them a page at a time instead of one &#x60;GET /titles/:id&#x60; each. Not &#x60;@IsUUID&#x60;: titles migrated from MSR2 keep their old ids.
         * @param {Array<TitleTypeEnum>} [titleTypes] Optional server-side filter by one or more program types. Matches titles whose &#x60;titleType&#x60; is any of the given values.  Note: legacy titles carry free-form &#x60;titleType&#x60; values that are not enum members (e.g. \&quot;Series (Fictional)\&quot;). Those titles cannot be matched here.
         * @param {string} [year] Optional server-side filter by production year. One year, not a list: the only control that sets it is a free-text field, and a title has exactly one production year, so there is nothing to multi-select.  Matched exactly against the stored &#x60;year&#x60;, as both a string and a number: titles written by this service store a string, documents that predate it store a BSON number, and &#x60;$in&#x60; is type-strict. Free-form values in the data are simply not matched rather than breaking the query.
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {string} [xCorrelationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerFindAllV2: (claimStatuses, clientIds, clientName, name, ownerClientIds, seriesOnly, serviceTypes, titleIds, titleTypes, year, workspaceId, page, pageSize, sortBy, xCorrelationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/title`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (claimStatuses) {
                localVarQueryParameter['claimStatuses'] = claimStatuses;
            }
            if (clientIds) {
                localVarQueryParameter['clientIds'] = clientIds;
            }
            if (clientName !== undefined) {
                localVarQueryParameter['clientName'] = clientName;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (ownerClientIds) {
                localVarQueryParameter['ownerClientIds'] = ownerClientIds;
            }
            if (seriesOnly !== undefined) {
                localVarQueryParameter['seriesOnly'] = seriesOnly;
            }
            if (serviceTypes) {
                localVarQueryParameter['serviceTypes'] = serviceTypes;
            }
            if (titleIds) {
                localVarQueryParameter['titleIds'] = titleIds;
            }
            if (titleTypes) {
                localVarQueryParameter['titleTypes'] = titleTypes;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (xCorrelationId != null) {
                localVarHeaderParameter['x-correlation-id'] = String(xCorrelationId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get title by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('titleControllerFindOne', 'id', id);
            const localVarPath = `/title/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a title by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerRemove: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('titleControllerRemove', 'id', id);
            const localVarPath = `/title/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an existing title
         * @param {string} id
         * @param {UpdateTitleDto} updateTitleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerUpdate: (id, updateTitleDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('titleControllerUpdate', 'id', id);
            // verify required parameter 'updateTitleDto' is not null or undefined
            assertParamExists('titleControllerUpdate', 'updateTitleDto', updateTitleDto);
            const localVarPath = `/title/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateTitleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TitlesApi - functional programming interface
 * @export
 */
export const TitlesApiFp = function (configuration) {
    const localVarAxiosParamCreator = TitlesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new title.
         * @param {CreateTitleDto} createTitleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerCreate(createTitleDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.titleControllerCreate(createTitleDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all titles for a workspace.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        titleControllerFindAll(workspaceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.titleControllerFindAll(workspaceId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all titles for a workspace.
         * @param {Array<ClaimStatusEnum>} [claimStatuses] Optional server-side filter by one or more claim statuses. Matches titles whose &#x60;claimStatus&#x60; is any of the given values.
         * @param {Array<string>} [clientIds] Owner client ids the frontend resolved from the search term (client names live in a separate DB, so the match happens client-side). When &#x60;name&#x60; is set, titles owned by any of these clients also match. Capped at 100 ids; &#x60;clientName&#x60; resolves the term server-side with no such cap.
         * @param {string} [clientName] Matches titles owned by clients whose name contains this term. Resolved server-side within &#x60;workspaceId&#x60;, which it requires.
         * @param {string} [name]
         * @param {Array<string>} [ownerClientIds] Optional server-side filter by owner client. Unlike &#x60;clientIds&#x60; — which the frontend resolves from the search term and which *widens* a name search — this narrows the result set, and so is AND-ed with every other filter.
         * @param {boolean} [seriesOnly] When true, return titles at series level: excludes child seasons/episodes (those carry a &#x60;serialTitleId&#x60;).
         * @param {Array<ServiceTypeEnum>} [serviceTypes] Optional server-side filter by one or more service types. Matches titles whose &#x60;serviceType[]&#x60; includes any of the given values.
         * @param {Array<string>} [titleIds] Optional server-side filter by title id, so a caller holding many ids (a CSV export naming each row\&#39;s title) reads them a page at a time instead of one &#x60;GET /titles/:id&#x60; each. Not &#x60;@IsUUID&#x60;: titles migrated from MSR2 keep their old ids.
         * @param {Array<TitleTypeEnum>} [titleTypes] Optional server-side filter by one or more program types. Matches titles whose &#x60;titleType&#x60; is any of the given values.  Note: legacy titles carry free-form &#x60;titleType&#x60; values that are not enum members (e.g. \&quot;Series (Fictional)\&quot;). Those titles cannot be matched here.
         * @param {string} [year] Optional server-side filter by production year. One year, not a list: the only control that sets it is a free-text field, and a title has exactly one production year, so there is nothing to multi-select.  Matched exactly against the stored &#x60;year&#x60;, as both a string and a number: titles written by this service store a string, documents that predate it store a BSON number, and &#x60;$in&#x60; is type-strict. Free-form values in the data are simply not matched rather than breaking the query.
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {string} [xCorrelationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerFindAllV2(claimStatuses, clientIds, clientName, name, ownerClientIds, seriesOnly, serviceTypes, titleIds, titleTypes, year, workspaceId, page, pageSize, sortBy, xCorrelationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.titleControllerFindAllV2(claimStatuses, clientIds, clientName, name, ownerClientIds, seriesOnly, serviceTypes, titleIds, titleTypes, year, workspaceId, page, pageSize, sortBy, xCorrelationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get title by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.titleControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a title by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerRemove(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.titleControllerRemove(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an existing title
         * @param {string} id
         * @param {UpdateTitleDto} updateTitleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerUpdate(id, updateTitleDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.titleControllerUpdate(id, updateTitleDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TitlesApi - factory interface
 * @export
 */
export const TitlesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TitlesApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new title.
         * @param {CreateTitleDto} createTitleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerCreate(createTitleDto, options) {
            return localVarFp
                .titleControllerCreate(createTitleDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all titles for a workspace.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        titleControllerFindAll(workspaceId, options) {
            return localVarFp
                .titleControllerFindAll(workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all titles for a workspace.
         * @param {Array<ClaimStatusEnum>} [claimStatuses] Optional server-side filter by one or more claim statuses. Matches titles whose &#x60;claimStatus&#x60; is any of the given values.
         * @param {Array<string>} [clientIds] Owner client ids the frontend resolved from the search term (client names live in a separate DB, so the match happens client-side). When &#x60;name&#x60; is set, titles owned by any of these clients also match. Capped at 100 ids; &#x60;clientName&#x60; resolves the term server-side with no such cap.
         * @param {string} [clientName] Matches titles owned by clients whose name contains this term. Resolved server-side within &#x60;workspaceId&#x60;, which it requires.
         * @param {string} [name]
         * @param {Array<string>} [ownerClientIds] Optional server-side filter by owner client. Unlike &#x60;clientIds&#x60; — which the frontend resolves from the search term and which *widens* a name search — this narrows the result set, and so is AND-ed with every other filter.
         * @param {boolean} [seriesOnly] When true, return titles at series level: excludes child seasons/episodes (those carry a &#x60;serialTitleId&#x60;).
         * @param {Array<ServiceTypeEnum>} [serviceTypes] Optional server-side filter by one or more service types. Matches titles whose &#x60;serviceType[]&#x60; includes any of the given values.
         * @param {Array<string>} [titleIds] Optional server-side filter by title id, so a caller holding many ids (a CSV export naming each row\&#39;s title) reads them a page at a time instead of one &#x60;GET /titles/:id&#x60; each. Not &#x60;@IsUUID&#x60;: titles migrated from MSR2 keep their old ids.
         * @param {Array<TitleTypeEnum>} [titleTypes] Optional server-side filter by one or more program types. Matches titles whose &#x60;titleType&#x60; is any of the given values.  Note: legacy titles carry free-form &#x60;titleType&#x60; values that are not enum members (e.g. \&quot;Series (Fictional)\&quot;). Those titles cannot be matched here.
         * @param {string} [year] Optional server-side filter by production year. One year, not a list: the only control that sets it is a free-text field, and a title has exactly one production year, so there is nothing to multi-select.  Matched exactly against the stored &#x60;year&#x60;, as both a string and a number: titles written by this service store a string, documents that predate it store a BSON number, and &#x60;$in&#x60; is type-strict. Free-form values in the data are simply not matched rather than breaking the query.
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {string} [xCorrelationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerFindAllV2(claimStatuses, clientIds, clientName, name, ownerClientIds, seriesOnly, serviceTypes, titleIds, titleTypes, year, workspaceId, page, pageSize, sortBy, xCorrelationId, options) {
            return localVarFp
                .titleControllerFindAllV2(claimStatuses, clientIds, clientName, name, ownerClientIds, seriesOnly, serviceTypes, titleIds, titleTypes, year, workspaceId, page, pageSize, sortBy, xCorrelationId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get title by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerFindOne(id, options) {
            return localVarFp
                .titleControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a title by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerRemove(id, options) {
            return localVarFp
                .titleControllerRemove(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing title
         * @param {string} id
         * @param {UpdateTitleDto} updateTitleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titleControllerUpdate(id, updateTitleDto, options) {
            return localVarFp
                .titleControllerUpdate(id, updateTitleDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * TitlesApi - object-oriented interface
 * @export
 * @class TitlesApi
 * @extends {BaseAPI}
 */
export class TitlesApi extends BaseAPI {
    /**
     *
     * @summary Create a new title.
     * @param {CreateTitleDto} createTitleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TitlesApi
     */
    titleControllerCreate(createTitleDto, options) {
        return TitlesApiFp(this.configuration)
            .titleControllerCreate(createTitleDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all titles for a workspace.
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TitlesApi
     */
    titleControllerFindAll(workspaceId, options) {
        return TitlesApiFp(this.configuration)
            .titleControllerFindAll(workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all titles for a workspace.
     * @param {Array<ClaimStatusEnum>} [claimStatuses] Optional server-side filter by one or more claim statuses. Matches titles whose &#x60;claimStatus&#x60; is any of the given values.
     * @param {Array<string>} [clientIds] Owner client ids the frontend resolved from the search term (client names live in a separate DB, so the match happens client-side). When &#x60;name&#x60; is set, titles owned by any of these clients also match. Capped at 100 ids; &#x60;clientName&#x60; resolves the term server-side with no such cap.
     * @param {string} [clientName] Matches titles owned by clients whose name contains this term. Resolved server-side within &#x60;workspaceId&#x60;, which it requires.
     * @param {string} [name]
     * @param {Array<string>} [ownerClientIds] Optional server-side filter by owner client. Unlike &#x60;clientIds&#x60; — which the frontend resolves from the search term and which *widens* a name search — this narrows the result set, and so is AND-ed with every other filter.
     * @param {boolean} [seriesOnly] When true, return titles at series level: excludes child seasons/episodes (those carry a &#x60;serialTitleId&#x60;).
     * @param {Array<ServiceTypeEnum>} [serviceTypes] Optional server-side filter by one or more service types. Matches titles whose &#x60;serviceType[]&#x60; includes any of the given values.
     * @param {Array<string>} [titleIds] Optional server-side filter by title id, so a caller holding many ids (a CSV export naming each row\&#39;s title) reads them a page at a time instead of one &#x60;GET /titles/:id&#x60; each. Not &#x60;@IsUUID&#x60;: titles migrated from MSR2 keep their old ids.
     * @param {Array<TitleTypeEnum>} [titleTypes] Optional server-side filter by one or more program types. Matches titles whose &#x60;titleType&#x60; is any of the given values.  Note: legacy titles carry free-form &#x60;titleType&#x60; values that are not enum members (e.g. \&quot;Series (Fictional)\&quot;). Those titles cannot be matched here.
     * @param {string} [year] Optional server-side filter by production year. One year, not a list: the only control that sets it is a free-text field, and a title has exactly one production year, so there is nothing to multi-select.  Matched exactly against the stored &#x60;year&#x60;, as both a string and a number: titles written by this service store a string, documents that predate it store a BSON number, and &#x60;$in&#x60; is type-strict. Free-form values in the data are simply not matched rather than breaking the query.
     * @param {string} [workspaceId]
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {string} [xCorrelationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TitlesApi
     */
    titleControllerFindAllV2(claimStatuses, clientIds, clientName, name, ownerClientIds, seriesOnly, serviceTypes, titleIds, titleTypes, year, workspaceId, page, pageSize, sortBy, xCorrelationId, options) {
        return TitlesApiFp(this.configuration)
            .titleControllerFindAllV2(claimStatuses, clientIds, clientName, name, ownerClientIds, seriesOnly, serviceTypes, titleIds, titleTypes, year, workspaceId, page, pageSize, sortBy, xCorrelationId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get title by Id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TitlesApi
     */
    titleControllerFindOne(id, options) {
        return TitlesApiFp(this.configuration)
            .titleControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a title by Id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TitlesApi
     */
    titleControllerRemove(id, options) {
        return TitlesApiFp(this.configuration)
            .titleControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing title
     * @param {string} id
     * @param {UpdateTitleDto} updateTitleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TitlesApi
     */
    titleControllerUpdate(id, updateTitleDto, options) {
        return TitlesApiFp(this.configuration)
            .titleControllerUpdate(id, updateTitleDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
